import { Helmet } from "react-helmet-async";

const SITE_NAME = "Self Preparation BD";
const DEFAULT_DESC = "Best books and eBooks platform in Bangladesh for job preparation, BCS, bank jobs and academic studies.";
const DEFAULT_IMAGE = "/og-image.png";

export default function SEO({ title, description, image, url, type = "website" }) {
    const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const pageDesc = description || DEFAULT_DESC;
    const pageImage = image || DEFAULT_IMAGE;

    return (
        <Helmet>

            <title>Self Publications | সরকারি চাকরি (১১–২০তম গ্রেড) প্রস্তুতির বিশ্বস্ত প্রকাশনী ও সেরা সমাধান</title>

            <meta name="author" content="Muhammad Mustak" />

            <meta name="description" content="মন্ত্রণালয়, বিভাগ, অধিদপ্তর, কর অঞ্চল, ডিসি অফিস সহ বিভিন্ন সরকারি দপ্তরের  ১১- ২০ তম গ্রেডের লিখিত ও MCQ প্রস্তুতির নির্ভরযোগ্য ও শ্রেষ্ঠ সহায়িকা সেল্ফ প্রকাশনীর বই" />
            
            <meta name="keywords" content="১১-২০ গ্রেড চাকরি প্রস্তুতি, সেল্ফ প্রকাশনী বই, সেল্ফ সিরিজ, Self Publications books, মন্ত্রণালয় চাকরি প্রস্তুতি বই, Grade 11-20 Job Preparation, Govt Job Preparation Book,government job, question bank, Recent Job solution, written preparation, mcq preparation, Ministy job, tax zone job, easy solution" />

            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={pageDesc} />
            <meta property="og:image" content={pageImage} />
            {url && <meta property="og:url" content={url} />}
            <meta property="og:type" content={type} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={pageDesc} />
            <meta name="twitter:image" content={pageImage} />
        </Helmet>
    );
}
